exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AnimationWidenShadow[data-v-0a90cf17]{-webkit-box-shadow:initial;box-shadow:none}.AnimationWidenShadow>div[data-v-0a90cf17]{display:-webkit-box;display:-ms-flexbox;display:flex}.AnimationWidenShadow[view][data-v-0a90cf17]{position:relative;-webkit-box-shadow:rgba(0,0,0,.3) 0 3px 6px 2px;box-shadow:0 3px 6px 2px rgba(0,0,0,.3);-webkit-transition:-webkit-box-shadow .4s ease-in-out .7s;transition:-webkit-box-shadow .4s ease-in-out .7s;transition:box-shadow .4s ease-in-out .7s;transition:box-shadow .4s ease-in-out .7s,-webkit-box-shadow .4s ease-in-out .7s}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a90cf17","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/effect/animation/AnimationWidenShadow.vue
// module id = 6kfF
// module chunks = 1